import { v4 as uuidv4 } from "uuid";
import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
class DriverResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.driverId = undefined;
        this.id = this.driverId ?? uuidv4();
        this.firstname = "";
        this.lastname = "";
        this.mobile = "";
        this.email = "";
        this.employeeNumber = "";
        this.costPlace = "";
        this.regNumber = "";
        this.privateMileage = "";
        this.workMileage = "";
    }
    pk() {
        return this.driverId?.toString() || this.id.toString();
    }
}
DriverResource.urlRoot = apiResourceUrl("drivers");
export { DriverResource };
//# sourceMappingURL=DriverResource.js.map